<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">

        </avue-crud>
    </basic-container>
</template>

<script>
import {
  getList,
  remove,
} from '@/api/v4ward/digitaltickets/invoicePurchaser';
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    labelWidth: 200,
                    searchShow: true,
                    searchMenuSpan: 25,
                    menuWidth: 250,
                    searchLabelWidth: 150,
                    border: true,
                    index: false,
                    editBtn: false,
                    viewBtn: false,
                    addBtn : false,
                    selection: false,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "id",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入id",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "抬头类型",
                                    prop: "headerType",
                                    dicUrl: "/api/blade-system/dict/dictionary?code=headerType",
                                    props: {
                                      label: "dictValue",
                                      value: "dictKey",
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择抬头类型",
                                        trigger: "change"
                                    }]
                                },
                                 {
                                    label: "发票抬头名称",
                                    prop: "name",
                                    width: 150,
                                    search: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入发票抬头名称",
                                        trigger: "change"
                                    }]
                                }, {
                                  label: "纳税人识别号",
                                  width: 150,
                                  prop: "taxNo",
                                  rules: [{
                                    required: true,
                                    message: "请输入纳税人识别号",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "注册地址",
                                  prop: "address",
                                  rules: [{
                                    required: true,
                                    message: "请输入注册地址",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "注册电话",
                                  prop: "phone",
                                  rules: [{
                                    required: true,
                                    message: "请输入注册电话",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "开户银行",
                                  prop: "depositBank",
                                  rules: [{
                                    required: true,
                                    message: "请输入开户银行",
                                    trigger: "change"
                                  }]
                                },
                              {
                                label: "开户银行账号",
                                width: 150,
                                prop: "bankNo",
                                rules: [{
                                  required: true,
                                  message: "请输入开户银行账号",
                                  trigger: "change"
                                }]
                              },
                              {
                                label: "接收电话",
                                prop: "receivePhone",
                                rules: [{
                                  required: true,
                                  message: "请输入接收电话",
                                  trigger: "change"
                                }]
                              },
                              {
                                label: "接收邮箱",
                                prop: "receiveMailbox",
                                rules: [{
                                  required: true,
                                  message: "请输入接收邮箱",
                                  trigger: "change"
                                }]
                              },
                    ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    delBtn: this.vaildData(this.permission.invoicepurchaser_delete, false),
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
